/**
 * @param {string} errorMessage
 */
export const isReachSendingMessageLimit = errorMessage => {
  const decodedErrorMessage = decodeURIComponent(errorMessage)
  return (
    decodedErrorMessage.includes("reach the limit of sending messages") ||
    decodedErrorMessage.includes("reach the limit of sign up")
  )
}

/**
 * @param {string} errorMessage
 */
export const isInvalidRecaptchaToken = errorMessage => {
  const decodedErrorMessage = decodeURIComponent(errorMessage)
  return decodedErrorMessage.toLowerCase().includes("invalid recaptcha token")
}

/**
 * @param {string} errorMessage
 */
export const isSuspiciousPhoneNumber = errorMessage => {
  const decodedErrorMessage = decodeURIComponent(errorMessage)
  return decodedErrorMessage.toLowerCase().includes("invalid phone number")
}
